'use client';

import {useCourseLandingComponentsApi} from '@/lib/hooks/use-course-landing-components-api';
import {useIsLoggedIn} from '@/lib/hooks/use-is-logged-in';
import {useUserHasOrganization} from '@/lib/hooks/use-user-has-organization';
import {OneClickCheckoutContext, OneClickCheckoutApiResponse} from '@/types/one-click-checkout-context';

export function useOneClickCheckoutContext(courseId: number) {
    const isLoggedIn = useIsLoggedIn();
    const userHasOrganization = useUserHasOrganization();

    const query = useCourseLandingComponentsApi<OneClickCheckoutApiResponse>(
        courseId,
        'one_click_checkout',
        {enabled: isLoggedIn && !userHasOrganization},
    );

    return {
        data: query.data?.one_click_checkout as OneClickCheckoutContext | undefined,
        isLoading: query.isLoading,
        error: (query.error ?? undefined) as Error | undefined,
    };
}
